import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from './Header';
import BackButton from './BackButton';
import Details from './Details';


function CountryDetails() {
  let { name } = useParams();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [countries, setCountry] = useState([]);
  const [theme, setTheme] = useState(true);

  useEffect(() => {
    fetch("https://restcountries.eu/rest/v2/all?fields=name;flag;nativeName;population;region;subregion;capital;topLevelDomain;currencies;languages;borders")
      .then(res => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setCountry(result);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )
  }, [])

  function handleThemeChange() {
    setTheme(!theme);
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <h1 className="text-2xl">Please wait...</h1>
      </div>
    );
  } else {
    return (
      theme ?
        <div className="min-h-screen bg-gray-200 transition-colors duration-300">
          <Header theme={theme} handleThemeChange={handleThemeChange} />
          <div className="container mx-auto flex flex-col px-6 pb-16  sm:px-16 md:px-10 lg:pb-10 xl:px-20">
            <BackButton theme={theme} />
            {
              countries.filter(country => country.name === name).map(selectedCountry => (
                <Details key={selectedCountry.name} country={selectedCountry} theme={theme} />
              ))
            }
          </div>
        </div> :
        <div className="min-h-screen bg-gray-900 transition-colors duration-300">
          <Header theme={theme} handleThemeChange={handleThemeChange} />
          <div className="container mx-auto flex flex-col px-6 pb-16 sm:px-16 md:px-10 lg:pb-10 xl:px-20">
            <BackButton theme={theme} />
            {
              countries.filter(country => country.name === name).map(selectedCountry => (
                <Details key={selectedCountry.name} country={selectedCountry} theme={theme} />
              ))
            }
          </div>
        </div>
    );
  }
}

export default CountryDetails;
